import { withInstall } from '/@/utils';
import collapseContainer from './src/collapse/CollapseContainer.vue';
import scrollContainer from './src/ScrollContainer.vue';
import lazyContainer from './src/LazyContainer.vue';
import { PageContainer, VxeContainer, QueryFilterContainer } from '@wahaha/wui-pro-components';

export const CollapseContainer = withInstall(collapseContainer);
export const ScrollContainer = withInstall(scrollContainer);
export const LazyContainer = withInstall(lazyContainer);

export { PageContainer, VxeContainer, QueryFilterContainer };

export * from './src/typing';
